import { HTMLAttributes } from 'react'
import { FooterContainer } from './styles'

type Props = {
  isFooterShadowVisible?: boolean
  children: React.ReactNode
} & HTMLAttributes<HTMLDivElement>

export const EditorMobileFooter = (props: Props) => {
  const { isFooterShadowVisible, children } = props

  return (
    <FooterContainer {...props} $isFooterShadowVisible={isFooterShadowVisible}>
      {children}
    </FooterContainer>
  )
}
